.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background-color: var(--tuna-surface-default);
}

.verdictLine {
  font-size: var(--tuna-typography-h3-fontSize);
  font-weight: 600;
}

.correct {
  color: var(--tuna-feedback-success);
}

.incorrect {
  color: var(--tuna-feedback-warning-text);
}

.explainer {
  color: var(--tuna-content-secondary);
  margin: 0;
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
  justify-content: flex-end;
}
